import { PlacementStudentV2 } from "../tutor-reports/tutorreport";
import { LatestLearningSection } from "./latest-learning-section";

export class StudentBookingStudentDetails {
  id: number;
  studentId: number;
  studentFullName: string;
  engagement: number;
  comprehension: number;
  attendance: string;
  reasonDescription: string;
  learnerComments: string;
  sessionsStart: Date;
  sessionsEnd: Date;
  latestLearningSection: LatestLearningSection;

  constructor(student?: PlacementStudentV2) {
    this.id = 0;
    this.studentId = 0;
    this.studentFullName = ""; 
    this.attendance = "";
    this.sessionsStart = null;
    this.sessionsEnd = null;
    this.engagement = 0;
    this.comprehension = 0;
    this.reasonDescription = "";
    this.learnerComments = "";
    this.latestLearningSection = { lastAssessmentScore: 'no assessment score completed', lastProgress: 'no progress completed', lastTarget: 'no target completed' };
    if (student) {
      this.studentId = student.studentId;
      this.studentFullName =  student.studentFirstName + " " + student.studentLastName; 
      this.attendance = 'Present';
      this.sessionsStart = student.sessionsStart;
      this.sessionsEnd = student.sessionsEnd;
    }
  }
}
